import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FormikFieldHelperText from '~components/field-helper-text/formik-field-helper-text';
import RangeDayPickerInput from './range-day-picker-input';

function FormikRangeDayPickerInput(props) {
  const { fieldConfig, FieldHelperTextProps, onClose, ...others } = props;
  const [field, meta, helpers] = useField(fieldConfig);
  return (
    <>
      <RangeDayPickerInput
        {...field}
        // onBlur will always be triggered when the datepicker opened
        // It's more reasonable to disable it
        onBlur={null}
        onChange={(date, value) => {
          if (value !== meta.value) {
            helpers.setValue(value);
          }
        }}
        onClose={(e) => {
          helpers.setTouched(true);
          onClose(e);
        }}
        {...others}
        InputProps={{ error: meta.touched && !!meta.error, ...others.InputProps }}
      />
      <FormikFieldHelperText {...FieldHelperTextProps} meta={meta} />
    </>
  );
}

FormikRangeDayPickerInput.propTypes = {
  fieldConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  FieldHelperTextProps: PropTypes.object,
  onClose: PropTypes.func,
  // all other props will be applied to InputBase component
};

FormikRangeDayPickerInput.defaultProps = {
  FieldHelperTextProps: undefined,
  onClose: () => {},
};

export default FormikRangeDayPickerInput;
